/* eslint-disable tailwindcss/no-custom-classname */
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { TermHead } from "@/components/organisms/TermHead";
import TermNav from "@/components/organisms/TermNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";

export default function IsmsPage(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"ISMS基本方針"}
        pageDescription={
          "株式会社トッカシステムズのISMS基本方針です。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/isms/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="mx-auto box-border flex max-w-6xl flex-col py-10 px-6 text-pri sm:px-8 md:px-12 md:pt-16 md:pb-24">
              <TermNav />
              <div className="order-1 md:order-2">
                <TermHead>
                  ISMS基本方針
                  <span className="ml-2 text-sm">（セキュリティ方針）</span>
                </TermHead>
                <div className="mx-auto max-w-4xl text-base text-txt-base ">
                  <div className="col-auto flex flex-col gap-4 ">
                    <div className="leading-7 md:leading-8">
                      {parse(
                        "当社では、お客様から信頼されるシステムソリューション企業として、品質の高いコンサルティング、及び、システム開発サービスの提供を通じ、利益と社会貢献を追求し、企業と個人の継続的発展と成長に努めております。当社は、お客様の情報をはじめ保有する情報資産を漏洩、改ざん、破壊、盗難などのあらゆる脅威から保護し、リスクを最小限に抑え、安全に活用することが実現される基本的な枠組みを定め、それを実践して行くことを目的とした情報セキュリティマネジメントシステム(ISMS)を導入し、情報セキュリティ基本方針を制定して、これを適切に維持・運営を行います。"
                      )}
                    </div>
                    <h4 className="leading-8 md:text-right">
                      制定日: 平成27年10月1日
                      <br />
                      株式会社トッカシステムズ
                      <br />
                      代表取締役社長　谷 樹
                    </h4>
                  </div>
                </div>
              </div>
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
